import { Scroll } from '../_app/cuchillo/scroll/Scroll';
import Scroll_Item from '../_app/cuchillo/scroll/Scroll_Item';

class ScrollItem__BlockDefault extends Scroll_Item {
  //==================================================================================================================
  //          CONSTRUCTOR
  //==================================================================================================================
  constructor(__link, __index, __scroller) {
    super(__link, __index, __scroller);

    this.onShow = () => { };
    this.onHide = () => { };
    this.onMove = () => { };
  }

  resize(__w, __h) {
    super.resize(__w, __h);
  }
}

Scroll._registerClass('BlockDefault', ScrollItem__BlockDefault);

export default ScrollItem__BlockDefault;
